"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var goodsNameTagApi = _interopRequireWildcard(require("@/api/goodsNameTagApi.js"));
var toolUtils = _interopRequireWildcard(require("@/utils/toolUtils.js"));
var _store = require("@/api/store");
var _selectProducts = _interopRequireDefault(require("../../business/supplier/coupons/selectProducts.vue"));
var _componentsApi = require("@/api/componentsApi");
var _ButtonUploadExcel = _interopRequireDefault(require("@/components/ButtonUploadExcel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectProducts: _selectProducts.default,
    ButtonUploadExcel: _ButtonUploadExcel.default
  },
  data: function data() {
    return {
      // 仅名称标签页覆盖选品列表接口，不影响 goodsTag
      bindSelectListApi: goodsNameTagApi.bindSelectListApi,
      visibleDrawer: false,
      constants: this.$constants,
      listPram: this.getDefaultListPram(),
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      importLoading: false,
      editDialogConfig: {
        visible: false,
        uploadFile: null
      },
      initDetail: {},
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true
      },
      merCateList: [],
      selectIds: [],
      selectLists: [],
      excelData: [],
      tagType: 1,
      needRefresh: false,
      conflictDialog: {
        visible: false,
        scene: 0,
        message: '',
        resolve: null
      }
    };
  },
  mounted: function mounted() {
    this.getCategorySelect();
    this.listData = {
      list: [],
      total: 0
    };
  },
  methods: {
    getDefaultListPram: function getDefaultListPram() {
      return {
        skuId: '',
        productName: '',
        page: 1,
        limit: this.$constants.page.limit[0]
      };
    },
    handleNumberSearchInput: function handleNumberSearchInput(field) {
      var value = String(this.listPram[field] || '').replace(/\D/g, '').slice(0, 50);
      this.listPram[field] = value;
    },
    downModal: function () {
      var _downModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _componentsApi.excelTemplateApi)('label_name_product.xlsx');
            case 1:
              res = _context.v;
              toolUtils.downloadFile(res.fileName, '商品名称标签批量模版');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      function downModal() {
        return _downModal.apply(this, arguments);
      }
      return downModal;
    }(),
    initOpen: function initOpen(row) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.tagType = type;
      this.initDetail = row || {};
      this.listPram = this.getDefaultListPram();
      this.handlerGetListData(this.listPram);
      this.visibleDrawer = true;
    },
    closeDrawer: function closeDrawer() {
      this.visibleDrawer = false;
      if (this.$refs.selectProductsRef) {
        this.$refs.selectProductsRef.closeEdit();
      }
      this.needRefresh && this.$emit('doRefresh');
    },
    handerSearch: function handerSearch() {
      var needRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.needRefresh = needRefresh;
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handleResetSearch: function handleResetSearch() {
      this.listPram = this.getDefaultListPram();
      this.handlerGetListData(this.listPram);
    },
    getSearchParams: function getSearchParams() {
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = _objectSpread({}, pram);
      ['skuId', 'productName'].forEach(function (key) {
        if (params[key] != null) {
          params[key] = String(params[key]).trim();
        }
        if (!params[key]) {
          delete params[key];
        }
      });
      return params;
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      var params = this.getSearchParams(_objectSpread(_objectSpread({}, pram), {}, {
        labelId: this.initDetail.id
      }));
      goodsNameTagApi.productListApi(params).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    getBindSkuLabelMap: function () {
      var _getBindSkuLabelMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var skuIdList,
          normalizedSkuIds,
          res,
          rawList,
          map,
          targetSet,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              skuIdList = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [];
              normalizedSkuIds = _toConsumableArray(new Set((skuIdList || []).map(function (id) {
                return String(id).trim();
              }).filter(Boolean)));
              if (normalizedSkuIds.length) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, new Map());
            case 1:
              _context2.n = 2;
              return goodsNameTagApi.bindSpuLabelListApi({
                skuIdList: normalizedSkuIds
              });
            case 2:
              res = _context2.v;
              rawList = Array.isArray(res) ? res : res && (res.list || res.data) ? res.list || res.data : [];
              map = new Map();
              targetSet = new Set(normalizedSkuIds);
              rawList.forEach(function (item) {
                var labelId = item && item.labelId !== undefined && item.labelId !== null ? String(item.labelId) : '';
                var labelName = item && item.labelName ? String(item.labelName) : '';
                var rawSkuList = Array.isArray(item && item.skuList) ? item.skuList : Array.isArray(item && item.spuList) ? item.spuList : [item && (item.skuId != null ? item.skuId : item.spuId)];
                rawSkuList.forEach(function (rawSkuId) {
                  var skuId = String(rawSkuId !== undefined && rawSkuId !== null ? rawSkuId : '').trim();
                  if (!skuId || !targetSet.has(skuId)) return;
                  if (!map.has(skuId)) map.set(skuId, []);
                  map.get(skuId).push({
                    labelId: labelId,
                    labelName: labelName
                  });
                });
              });
              return _context2.a(2, map);
          }
        }, _callee2);
      }));
      function getBindSkuLabelMap() {
        return _getBindSkuLabelMap.apply(this, arguments);
      }
      return getBindSkuLabelMap;
    }(),
    getDuplicateLabelGroups: function getDuplicateLabelGroups() {
      var skuIdList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var bindMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
      var normalizedSkuIds = _toConsumableArray(new Set((skuIdList || []).map(function (id) {
        return String(id).trim();
      }).filter(Boolean)));
      var targetSet = new Set(normalizedSkuIds);
      var groupMap = new Map();
      normalizedSkuIds.forEach(function (skuId) {
        var bindings = bindMap.get(skuId) || [];
        bindings.forEach(function (binding) {
          var groupKey = "".concat(binding.labelId || '', "__").concat(binding.labelName || '');
          if (!groupMap.has(groupKey)) {
            groupMap.set(groupKey, {
              labelId: binding.labelId || '',
              labelName: binding.labelName || '',
              skuList: []
            });
          }
          var group = groupMap.get(groupKey);
          if (targetSet.has(skuId) && !group.skuList.includes(skuId)) {
            group.skuList.push(skuId);
          }
        });
      });
      return Array.from(groupMap.values()).filter(function (group) {
        return group.skuList.length > 0;
      });
    },
    buildDuplicateConfirmText: function buildDuplicateConfirmText() {
      var duplicateGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!duplicateGroups.length) return '';
      var parts = duplicateGroups.map(function (group) {
        var labelName = group.labelName || (group.labelId ? "\u6807\u7B7E".concat(group.labelId) : '未知标签');
        return "".concat(labelName, "\u6807\u7B7E\u4E0B\u7684skuId\uFF1A").concat(group.skuList.join('，'));
      });
      return "".concat(parts.join('，'), "\u91CD\u590D\uFF0C\u662F\u5426\u9700\u8981\u8986\u76D6\uFF1F");
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectLists = selection || [];
      this.selectIds = (selection || []).map(function (item) {
        return item.skuId != null ? item.skuId : item.id;
      });
    },
    getCategorySelect: function getCategorySelect() {
      var _this2 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this2.merCateList = res;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    handlerOpenEdit: function handlerOpenEdit() {
      this.editDialogConfig.visible = true;
      this.excelData = [];
    },
    submitImport: function () {
      var _submitImport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var skuIds, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              skuIds = _toConsumableArray(new Set((this.excelData || []).map(function (id) {
                return Number(id);
              }).filter(function (id) {
                return !Number.isNaN(id);
              })));
              if (skuIds.length) {
                _context3.n = 1;
                break;
              }
              this.$message.warning('请检查导入文件是否包含skuId！');
              return _context3.a(2);
            case 1:
              this.importLoading = true;
              _context3.p = 2;
              _context3.n = 3;
              return this.submitBindByIds(skuIds, 0);
            case 3:
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t = _context3.v;
            case 5:
              _context3.p = 5;
              this.importLoading = false;
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4, 5, 6]]);
      }));
      function submitImport() {
        return _submitImport.apply(this, arguments);
      }
      return submitImport;
    }(),
    batchRemove: function batchRemove(removeSkuIds) {
      var _this3 = this;
      var skuIds = _toConsumableArray(new Set((removeSkuIds || []).map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return !Number.isNaN(id);
      })));
      if (!skuIds.length) {
        this.$message.warning('请选择要移除的商品');
        return;
      }
      this.$confirm('移除后数据不能被恢复，确认移除吗！', '确定移除').then(function () {
        goodsNameTagApi.deleteBindApi({
          labelId: _this3.initDetail.id,
          skuIds: skuIds
        }).then(function () {
          _this3.$message.success('删除数据成功');
          _this3.handerSearch(1);
          _this3.selectIds = [];
          _this3.selectLists = [];
        });
      }).catch(function () {});
    },
    addProducts: function addProducts() {
      this.$refs.selectProductsRef.openInit(this.initDetail.id);
    },
    getSelectProduct: function () {
      var _getSelectProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(selectedItems) {
        var skuIds, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              skuIds = _toConsumableArray(new Set((selectedItems || []).map(function (item) {
                if (!item || _typeof(item) !== 'object') return item;
                return item.skuId != null ? item.skuId : item.id;
              }).map(function (id) {
                return Number(id);
              }).filter(function (id) {
                return !Number.isNaN(id);
              })));
              if (skuIds.length) {
                _context4.n = 1;
                break;
              }
              this.$message.warning('请选择有效的商品');
              return _context4.a(2);
            case 1:
              _context4.p = 1;
              _context4.n = 2;
              return this.submitBindByIds(skuIds, 0);
            case 2:
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t2 = _context4.v;
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function getSelectProduct(_x) {
        return _getSelectProduct.apply(this, arguments);
      }
      return getSelectProduct;
    }(),
    /** 选择商品/导入绑定：先校验(confirmAction=0)，冲突后再按用户选择传 1/2 */submitBindByIds: function () {
      var _submitBindByIds = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(skuIds, confirmAction) {
        var res, nextAction, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return goodsNameTagApi.bindImportByIdsApi({
                labelId: this.initDetail.id,
                skuIds: skuIds,
                confirmAction: confirmAction
              });
            case 1:
              _t3 = _context5.v;
              if (_t3) {
                _context5.n = 2;
                break;
              }
              _t3 = {};
            case 2:
              res = _t3;
              if (!(res.success && !res.needConfirm)) {
                _context5.n = 3;
                break;
              }
              this.$message.success(res.message || '操作成功！');
              if (this.$refs.selectProductsRef) {
                this.$refs.selectProductsRef.closeEdit();
              }
              this.editDialogConfig.visible = false;
              this.excelData = [];
              this.handerSearch(1);
              return _context5.a(2);
            case 3:
              if (res.needConfirm) {
                _context5.n = 4;
                break;
              }
              this.$message.error(res.message || '操作失败');
              return _context5.a(2);
            case 4:
              _context5.n = 5;
              return this.resolveBindConflict(res);
            case 5:
              nextAction = _context5.v;
              if (!(nextAction == null)) {
                _context5.n = 6;
                break;
              }
              return _context5.a(2);
            case 6:
              _context5.n = 7;
              return this.submitBindByIds(skuIds, nextAction);
            case 7:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function submitBindByIds(_x2, _x3) {
        return _submitBindByIds.apply(this, arguments);
      }
      return submitBindByIds;
    }(),
    /**
     * 冲突确认
     * scene: 2 单条达上限 / 3 混合 / 4 全部达上限
     * 返回 confirmAction: 1全部覆盖 2仅正常；取消返回 null
     */
    resolveBindConflict: function resolveBindConflict() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var scene = Number(res.scene);
      var message = res.message && String(res.message).trim() || this.buildBindConflictMessage(res);
      // scene 3：确认 / 仅导入正常SKUID / 取消
      if (scene === 3) {
        return this.openConflictDialog(scene, message);
      }
      // scene 2 / 4：确认 / 取消
      return this.$confirm(message, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(function () {
        return 1;
      }).catch(function () {
        return null;
      });
    },
    /** 按文档场景拼兜底文案（优先用接口 message） */buildBindConflictMessage: function buildBindConflictMessage() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var scene = Number(res.scene);
      var labelName = res.labelName || this.initDetail.labelName || '';
      var conflictSkuIds = Array.isArray(res.conflictSkuIds) ? res.conflictSkuIds : [];
      var conflictText = conflictSkuIds.join(', ');
      if (scene === 2) {
        var skuText = conflictText || (conflictSkuIds[0] != null ? conflictSkuIds[0] : '');
        return "SKUID [ ".concat(skuText, " ] \u5DF2\u5173\u80542\u4E2A\u6807\u7B7E\uFF08\u5DF2\u8FBE\u4E0A\u9650\uFF09\uFF0C\u65E0\u6CD5\u76F4\u63A5\u8FFD\u52A0\u3002\u82E5\u7EE7\u7EED\u64CD\u4F5C\uFF0C\u5C06\u6E05\u9664\u8BE5SKUID\u539F\u6709\u6807\u7B7E\uFF0C\u5E76\u66FF\u6362\u4E3A\u5F53\u524D\u6807\u7B7E [ ").concat(labelName, " ]\u3002\u662F\u5426\u786E\u8BA4\u8986\u76D6\uFF1F");
      }
      if (scene === 3) {
        var totalCount = res.totalCount != null ? res.totalCount : '';
        var conflictCount = res.conflictCount != null ? res.conflictCount : conflictSkuIds.length;
        return "\u672C\u6B21\u5171\u5BFC\u5165 ".concat(totalCount, " \u4E2ASKUID\uFF0C\u5176\u4E2D ").concat(conflictCount, " \u4E2ASKUID\u5DF2\u5173\u80542\u4E2A\u6807\u7B7E\uFF08\u5DF2\u8FBE\u4E0A\u9650\uFF09\u3002\u51B2\u7A81SKUID\u5217\u8868\uFF1A").concat(conflictText, "\u3002\u7EE7\u7EED\u5BFC\u5165\u5C06\u6E05\u9664\u4EE5\u4E0ASKUID\u7684\u539F\u6709\u6807\u7B7E\uFF0C\u5E76\u66FF\u6362\u4E3A\u5F53\u524D\u6807\u7B7E [ ").concat(labelName, " ]\uFF1B\u5176\u4F59\u6B63\u5E38SKUID\u5C06\u76F4\u63A5\u8FFD\u52A0\u6807\u7B7E\u3002\u662F\u5426\u786E\u8BA4\u7EE7\u7EED\uFF1F");
      }
      if (scene === 4) {
        return "\u6240\u6709\u5F85\u5BFC\u5165SKUID\u5747\u5DF2\u5173\u80542\u4E2A\u6807\u7B7E\uFF08\u5DF2\u8FBE\u4E0A\u9650\uFF09\u3002\u7EE7\u7EED\u64CD\u4F5C\u5C06\u6E05\u7A7A\u8FD9\u4E9BSKUID\u7684\u539F\u6709\u6807\u7B7E\uFF0C\u7EDF\u4E00\u66FF\u6362\u4E3A\u5F53\u524D\u6807\u7B7E [ ".concat(labelName, " ]\u3002\u662F\u5426\u786E\u8BA4\u5168\u90E8\u8986\u76D6\uFF1F");
      }
      return '存在冲突，是否继续？';
    },
    openConflictDialog: function openConflictDialog(scene, message) {
      var _this4 = this;
      return new Promise(function (resolve) {
        _this4.conflictDialog = {
          visible: true,
          scene: scene,
          message: message,
          resolve: resolve
        };
      });
    },
    handleConflictAction: function handleConflictAction(action) {
      var resolve = this.conflictDialog.resolve;
      this.conflictDialog.visible = false;
      this.conflictDialog.resolve = null;
      if (typeof resolve === 'function') resolve(action);
    },
    handleConflictDialogClose: function handleConflictDialogClose() {
      if (typeof this.conflictDialog.resolve === 'function') {
        var resolve = this.conflictDialog.resolve;
        this.conflictDialog.resolve = null;
        resolve(null);
      }
    },
    onSuccess: function onSuccess(excelData) {
      var _ref = excelData || {},
        results = _ref.results;
      var skuIdList = [];
      var pickSkuId = function pickSkuId(item) {
        if (!item || _typeof(item) !== 'object') return '';
        var keys = Object.keys(item);
        var skuKey = keys.find(function (k) {
          return String(k).trim().toLowerCase() === 'skuid';
        }) || keys.find(function (k) {
          return String(k).trim().toLowerCase().replace(/[_\s-]/g, '') === 'skuid';
        });
        var raw = skuKey != null ? item[skuKey] : Object.values(item)[0];
        return String(raw == null ? '' : raw).trim();
      };
      // sheet_to_json 已把首行当表头，results 即 skuId 列下的数据行
      (results || []).forEach(function (item) {
        var skuId = pickSkuId(item);
        if (skuId && /^\d+$/.test(skuId)) {
          skuIdList.push(skuId);
        }
      });
      this.excelData = _toConsumableArray(new Set(skuIdList));
      if (!this.excelData.length) {
        this.$message.warning('未识别到有效的skuId，请检查导入模板');
        return;
      }
      this.$message.success("\u4E0A\u4F20\u6210\u529F\uFF0C\u5DF2\u89E3\u6790 ".concat(this.excelData.length, " \u4E2AskuId"));
    }
  }
};